module.exports = __webpack_public_path__ + "img/image-4.3beaf78c.jpg";